import thLang from "./entries/th-TH";
import enLang from "./entries/en-US";

const AppLocale = {
  th: thLang,
  en: enLang,
};
export default AppLocale;
